import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { environment } from '../environment';
import { Module } from '../models/module';

@Component({
  selector: 'app-modules',
  templateUrl: './modules.townsquare.component.html'
})
export class TownSquareComponent implements OnInit {

	title: string;
	header: any;
	headerHeight: any;
  headerAlign: any;
  subtitle: string;
  progressCounter: any;
  modules: Module;
  hoursToday: number;

  progressbar = 0;
  progress = 89;
  
  constructor(private http      : Http,
              private sanitizer : DomSanitizer ) {}

  runProgress() {
    if ( this.progressbar < this.progress ) {
      this.progressbar = this.progressbar+1;
      setTimeout( () => { 
        this.runProgress();
      }, 20);
    }
  }

  /* On with the show */
  ngOnInit() {

  	this.title = 'TOWN SQUARE';
    this.header = this.sanitizer.bypassSecurityTrustStyle( 'url("/assets/img/statistics-bg.jpg") 100%' );
  	this.subtitle = 'Identity\'s first module and social gathering place.';
    this.headerHeight = '50vh';
    this.runProgress();

    // Hours since midnight for tracker
    var d = new Date(), e = new Date(d);
    var dateDiff = (+d - e.setHours(0,0,0,0));
    this.hoursToday = Math.floor(dateDiff / 1000 / 60 / 60);
  }

}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/modules/modules.townsquare.component.ts